import { Directive, OnDestroy, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import {
  Address,
  Country,
  GlobalMessageService,
  GlobalMessageType,
  isNotNullable,
  UserAddressService
} from '@spartacus/core'
import { combineLatest, Subscription } from 'rxjs'
import { filter, map, tap } from 'rxjs/operators'
import { MbCheckoutStepService } from '../../services/mb-checkout-step.service'
import { MbCheckoutCommonService } from '../../services/mb-checkout-common.service'
import { MbCheckoutDeliveryFacade } from '../../facades/mb-checkout-delivery.facade'
import { MbCheckoutShippingFacade } from '../../facades/mb-checkout-shipping.facade'
import { MbConstants } from '../../../shared/mb-constants'
import { ActiveCartFacade } from '@spartacus/cart/base/root'

@Directive()
export class MbCheckoutShippingAddressBase implements OnInit, OnDestroy {

  subscription: Subscription = new Subscription()
  showAddNewAddressForm = false
  country: Country | undefined
  selectedAddress: Address | undefined
  constants = MbConstants
  selectedAddress$ = this.activeCartService.getActive().pipe(
    filter(isNotNullable),
    map(cart => {
      const { deliveryAddress } = cart
      if (deliveryAddress && this.selectedAddress?.id !== deliveryAddress.id &&
        deliveryAddress.verificationStatus !== this.constants.ADDRESS_VERIFIED_REJECTED_STATUS_04) {
        this.selectedAddress = deliveryAddress
        return this.selectedAddress
      } else {
        return
      }
    })
  )
  addresses$ = combineLatest([
    this.userAddressService.getAddresses(),
    this.selectedAddress$,
  ]).pipe(
    tap(([addresses, selected]) => {
      if (selected && selected?.id !== this.selectedAddress?.id) {
        this.addressSelectedHandler(selected)
      }
    }),
    map(([addresses, selected]) => addresses)
  )

  constructor (protected activatedRoute: ActivatedRoute,
               protected activeCartService: ActiveCartFacade,
               protected userAddressService: UserAddressService,
               protected mbCheckoutStepService: MbCheckoutStepService,
               protected mbCheckoutCommonService: MbCheckoutCommonService,
               protected mbCheckoutShippingFacade: MbCheckoutShippingFacade,
               protected globalMessageService: GlobalMessageService,
               protected mbCheckoutDeliveryService: MbCheckoutDeliveryFacade) {
  }

  ngOnInit () {
    this.subscription?.add(this.mbCheckoutShippingFacade.isAddNewAddressesFormVisible.pipe(
      tap(showAddNewAddressForm => this.showAddNewAddressForm = showAddNewAddressForm)
    ).subscribe())

    this.subscription?.add(this.mbCheckoutCommonService.userCountry.pipe(
      tap(userCountry => this.country = userCountry)
    ).subscribe())

    this.subscription?.add(this.activeCartService.isGuestCart().pipe(
      tap(isGuestCart => !isGuestCart ? this.userAddressService.loadAddresses() : undefined)
    ).subscribe())
  }

  ngOnDestroy (): void {
    this.subscription?.unsubscribe()
  }

  next (): void {
    if (this.selectedAddress) {
      this.mbCheckoutStepService.next(this.activatedRoute)
    } else {
      this.globalMessageService.add({ key: 'address.mandatoryMissingError' }, GlobalMessageType.MSG_TYPE_ERROR)
    }
  }

  back () {
    this.mbCheckoutStepService.back(this.activatedRoute)
  }

  toggleShowAddNewAddressForm () {
    this.mbCheckoutShippingFacade.openAddNewAddressForm()
  }

  addressSelectedHandler (address: Address) {
    this.mbCheckoutDeliveryService.setDeliveryAddressWithoutDeliveryMode(address)
  }
}
